<template>
  <v-card>
    <v-app-bar flat dense>
      <v-toolbar-title
        ><span class="title">Callback logs</span></v-toolbar-title
      >
      <v-spacer></v-spacer>
      <v-btn icon @click="getData">
        <v-icon color="indigo">refresh</v-icon>
      </v-btn>
      <!--<v-btn outlined small color="indigo" @click="dialog = true">-->
      <!--New App-->
      <!--</v-btn>-->
      <!--<v-btn icon> <v-icon>more_vert</v-icon> </v-btn>-->
    </v-app-bar>
    <v-divider></v-divider>
    <v-card-text class="pa-0">
      <v-data-table
        dense
        :headers="headers"
        :items="listCallbacks"
        item-key="id"
        :options.sync="pagination"
        :server-items-length="totalCallbacks"
        :loading="loading"
        :footer-props="footerOptions"
        :mobile-breakpoint="0"
      >
        <template v-slot:item="props">
          <tr>
            <td class="text-xs-left">
              {{ props.item.id }}
            </td>
            <td class="text-xs-left">Order {{ props.item.order_id }}</td>
            <td class="text-xs-left">
              <v-chip label small outlined color="primary">{{
                props.item.order_status | uppercase
              }}</v-chip>
            </td>
            <td class="text-xs-left">
              <v-chip label small outlined color="green">{{
                props.item.response_code
              }}</v-chip>
            </td>
            <td class="text-xs-left">
              {{ props.item.retries }}
            </td>
            <td class="text-xs-left">
              {{ props.item.request_at | moment("DD/MM/YYYY HH:mm:ss") }}
            </td>
            <td class="justify-center">
              <v-icon small class="mr-2" @click="editItem(props.item)">
                open_in_new
              </v-icon>
            </td>
          </tr>
        </template>
      </v-data-table>
      <v-divider></v-divider>
    </v-card-text>

    <v-dialog v-model="dialog" persistent max-width="600">
      <v-card>
        <v-card-text>
          <h3 class="title">URL: {{ newApp.request_path }}</h3>
          <h3 class="title">Callback data</h3>
          <code class="caption blue--text">{{ newApp.request_data }}</code>
          <h3 class="title">Response</h3>
          <code class="caption green--text">{{ newApp.response_data }}</code>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="cancel">{{
            $t("button.close")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      :timeout="3000"
      bottom
      right
      :color="snackbar.color"
      v-model="snackbar.show"
    >
      {{ snackbar.text }}
      <v-btn dark text @click.native="snackbar.show = false" icon>
        <v-icon>close</v-icon>
      </v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "TableResponse",
  data() {
    return {
      dialog: false,
      loading: false,
      pagination: {
        page: 1,
        itemsPerPage: 10
      },
      footerOptions: {
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageOptions: [5, 10, 15, 20, 25, 30]
      },
      headers: [
        { text: "ID", sortable: false, width: "100" },
        { text: "Order", sortable: false, width: "100" },
        { text: "Order status", sortable: false, width: "100" },
        { text: "Callback Status", sortable: false, width: "150" },
        { text: "Retries", sortable: false, width: "200" },
        { text: "Time", sortable: false, width: "200" },
        { text: "", sortable: false, width: "50" }
      ],
      colors: {
        unconfirmed: "blue",
        pending: "orange",
        paid: "green",
        expired: "pink",
        illegal: "red"
      },
      editedIndex: -1,
      newApp: {},
      defaultItem: {},
      snackbar: {
        show: false,
        text: "",
        color: ""
      }
    };
  },
  computed: {
    ...mapGetters(["listCallbacks", "totalCallbacks"]),
    formTitle() {
      return "Request log";
    }
  },
  methods: {
    getData() {
      this.loading = true;
      this.$store
        .dispatch("fetchListCallback", {
          page: this.pagination.page,
          per_page: this.pagination.itemsPerPage
        })
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.newApp = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    editItem(item) {
      this.editedIndex = this.listCallbacks.indexOf(item);
      this.newApp = Object.assign({}, item);
      this.dialog = true;
    },
    cancel() {
      this.close();
    }
  },
  mounted() {
    this.getData();
  },
  watch: {
    pagination: {
      handler() {
        this.getData();
      },
      deep: true
    }
  }
};
</script>
